import React from 'react';
import { useSelector } from 'react-redux';
import { AppSelectors } from '../../../selectors';

import * as S from './styles';

const ImageBackground = ({ images }) => {
  const supportsWebp = useSelector((state) => AppSelectors.makeSupportsWebp(state));

  return supportsWebp ? <S.ImageBackground images={images.webp} /> : <S.ImageBackground images={images.default} />;
};

export default ImageBackground;
